import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Router } from '@angular/router';
import { BASE_URL } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class NotificationsService {

	constructor(
		private http: Http,
		private router: Router,
		private toastr: ToastrService,
	) { }

	private loginHeaders = new Headers({ 'Content-Type': 'application/json' });
	private loginOptions = new RequestOptions({ headers: this.loginHeaders });

	//Header with token
	private getToken() {
		const token = localStorage.getItem('securityToken');
		if (token) {
			const headers = new Headers({
				'Content-Type': 'application/json',
				'Securitytoken': token,
			});
			return new RequestOptions({ headers: headers });
		}
	}

	private getClientId() {
		const clientObject = { "client_id" : localStorage.getItem('clientId') };
		return clientObject;
	}

	getNotificationsList(offset, limit, draw, filter, order_column, order_direction) {
		return this.http.get(BASE_URL + `notifications/custom?start=${offset}&length=${limit}&search[value]=${filter}&draw=${draw}&order[0][column]=${order_column}&order[0][dir]=${order_direction}`, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
	}

	addNotification(data) {
		return this.http.post(`${BASE_URL}notifications/custom`, data, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
	}

	getSpecificNotification(id) {
		return this.http.get(`${BASE_URL}notifications/custom/${id}`, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
	}

	deleteNotification(id) {
		return this.http.delete(`${BASE_URL}notifications/custom/${id}`, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
	}

	getAllNotificationsRecipients(id, offset, filter_term) {
		return this.http.get(`${BASE_URL}notifications/custom/${id}/recipients?offset=${offset}&filter_term=${filter_term}`, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
	}

	getNotificationsStatus() {
		return this.http.get(`${BASE_URL}notifications/special_offer/settings`, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});		
	}

	setNotificationsStatus(data) {
		return this.http.put(`${BASE_URL}notifications/special_offer/settings`, data, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});	
	}

	//Error function
	_handleError(error) {
		if (error.status === 401 || error.status === 455 || error.status === 403 || error.status === 498) {
			this.toastr.warning('Vaš sigurnosni token je istekao, molimo prijavite se ponovno');
			localStorage.clear();
			this.router.navigate([`/login`]);
		} else {
			return Observable.throw(error.json());
		}
	}
}



// WEBPACK FOOTER //
// /Users/Miroslav/Projects/Dubravica/backoffice/src/app/services/notifications/notifications.service.ts